import React, { createContext, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ConnectionsUI, getUnsupportedMarketplaces } from '@shipstation/connections-ui';
import { useCommonCuiProps } from '../connection-components/helpers/use-common-cui-props';
import { useEnableRemoveIframeMarketplace } from '../feature-flags/hooks/use-enable-remove-iframe-marketplace';

export const CUIContext = createContext();
export const useCUIContext = () => useContext(CUIContext);

const EMPTY_SET = new Set();

export const CUIContextProvider = ({ children }) => {
  const isDirectMode = useEnableRemoveIframeMarketplace();
  const commonCuiProps = useCommonCuiProps();
  const [unsupportedMarketplaces, setUnsupportedMarketplaces] = useState(EMPTY_SET);
  const value = useMemo(() => ({ unsupportedMarketplaces }), [unsupportedMarketplaces]);

  const loadUnsupported = () => getUnsupportedMarketplaces().then((marketplaces) => setUnsupportedMarketplaces(new Set(marketplaces)));

  return (
    <>
      {isDirectMode ? null : <ConnectionsUI {...commonCuiProps} onInitialized={loadUnsupported} />}
      <CUIContext.Provider value={value}>{children}</CUIContext.Provider>
    </>
  );
};

CUIContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
